module.exports = "/_next/static/images/4ace525b4defe30c06fe4a458f22e104-rewards-home-card@2x.png.webp";